import React, { FunctionComponent } from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export type CustomBreadcrumbsMoleculeProps = {
  breadcrumbs: {
    label: string;
    link: string;
  }[]
}

export const CustomBreadcrumbsMolecule: FunctionComponent<CustomBreadcrumbsMoleculeProps> = ({breadcrumbs}) => {
  return (
    <Breadcrumbs separator=">">
      {breadcrumbs.map((breadcrumb, index) => {
        const {label, link} = breadcrumb;
        const lastIndex = breadcrumbs.length - 1;

        const renderTypo = () => {
          return (
            <Typography
              color="text.primary"
              key={label+index}
              sx={{fontWeight: index === lastIndex ? "bold" : "normal"}}
            >
              {label}
            </Typography>  
          );
        };

        if (link) {
          return (
            <Link to={link} key={label+index}>
              {renderTypo()}
            </Link>
          );
        }

        return renderTypo();
      })}
    </Breadcrumbs>
  );
};